<template>
  <el-dialog width="800px"
             v-dialog-drag
             title="草稿箱"
             :before-close="handleClickCancel"
             :close-on-press-escape="false"
             :close-on-click-modal="false"
             :visible.sync="weChatDraftsVisible">
    <el-form size="small"
             ref="draftForm"
             label-position="top"
             label-width="85px"
             :model="draftForm"
             :rules="draftFormRules" v-loading="loading">
      <div style="margin-bottom: 16px">
        <el-table :data="tableData" max-height="600"  border   style="width: 100%" @cell-click="handleClickCell">
          <el-table-column  fixed prop="change"  label="选择" align="center" width="60">
            <template slot-scope="{row}">
              <div class="custom_radio">
                <el-radio v-model="draftId" :label="row.draft_id"> </el-radio>
              </div>
            </template>
          </el-table-column>
          <el-table-column  prop="user_version" label="版本号" align="center" width="80" show-overflow-tooltip	> </el-table-column>
          <el-table-column  prop="user_desc" label="描述"  align="center"  min-width="120" show-overflow-tooltip	> </el-table-column>
          <el-table-column  prop="draft_id" label="ID" align="center"  width="80" show-overflow-tooltip	> </el-table-column>
          <el-table-column  prop="create_time" label="上传草稿时间"  align="center" width="160" show-overflow-tooltip	>
            <template slot-scope="{row}">
              <span v-text="timeDate(row.create_time)"></span>
            </template>
          </el-table-column>
          <el-table-column  prop="developer" label="操作者微信昵称"  align="center" width="130" show-overflow-tooltip	></el-table-column>
        </el-table>
      </div>

      <el-form-item label="对应模板库" prop="template_type">
        <el-select v-model="draftForm.template_type" placeholder="请选择展项分类">
          <el-option  v-for="item in templateList"   :key="item.value"   :label="item.name"  :value="item.value"> </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="small"   :disabled="btnDisabled" @click="handleClickCancel">取消</el-button>
      <el-button size="small"   :disabled="btnDisabled" @click="handleClickConfirm" type="primary">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { getTemplatedRaftList,addToTemplate} from "@/api";
export default {
  name: "wechat_drafts",
  props: {
    weChatDraftsVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      btnDisabled: false,
      tableData:[],
      draftForm: {
        template_type: '',

      },
      draftFormRules: {
        template_type: [{required: true, message: '请上传到对应模版库', trigger: 'change'},],
      },
      templateList:[
        {value:0,name:'普通模板'},
        {value:1,name:'标准模板库'},
      ],
      draftId:null
    }
  },
  created() {

    this.getTableData()
  },
  mounted() {
  },
  methods: {

    handleClickCell(row, column, cell, event){
      this.draftId = row.draft_id
    },
    getTableData() {
      this.loading = true
      getTemplatedRaftList({ }).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.draft_list
          if( res.data.draft_list && res.data.draft_list.length>0){
            this.draftId =  res.data.draft_list[0].draft_id
          }
        }
        this.loading = false
      })
    },

    timeDate(timestampInSeconds ){
      // 转换为毫秒
      const timestampInMilliseconds = timestampInSeconds * 1000;
      // 创建 Date 对象
      const date = new Date(timestampInMilliseconds);
      //    自定义格式：YYYY-MM-DD HH:mm:ss
      const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
      return formattedDate
    },

    handleClickCancel() {
      this.$emit('update:weChatDraftsVisible', false)
    },

    handleClickConfirm() {
      this.$refs.draftForm.validate(valid => {
        if (valid) {
          this.btnDisabled = true
          addToTemplate({
            draft_id:this.draftId,
            template_type:this.draftForm.template_type,
          }).then(res => {
            if(res.data.errcode == 0){
              this.$message.success('操作成功')
              this.$emit('success')
              this.$refs.draftForm.resetFields()
              this.$emit('update:weChatDraftsVisible', false)
            }else{
              this.$message.success(res.data.errmsg)
            }

          }).catch(() => {
            this.btnDisabled = false
          })
        } else {
          return false
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.el-date-editor.el-input {
  width: 100%;
}
.custom_radio ::v-deep .el-radio__label{
  display: none;
}
</style>
